import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
    titleWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    titleHeading: {
        color: theme.palette.primary.main,
        fontSize: "22px",
        fontWeight: "600",
        lineHeight: "25px",
    },
    dialogContent: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "20px",
    },
    drawerTitle: {
        position: "sticky",
        top: 0,
        padding: "14px 16px",
        backgroundColor: theme.palette.common.white,
    },
    drawerContent: {
        padding: "14px 16px",
        fontSize: "14px",
        fontWeight: 400,
    },
    drawerRoot: {
        height: '100%',
    },
    drawerPaper: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin: theme.spacing(0),
            height: '100%',
        },
    },
    label: {
        fontSize: theme.typography.h4.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
    },
    actionContainer: {
        marginTop: theme.spacing(2),
        color: theme.palette.success.main,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: "14px 16px",
            position: "fixed",
            bottom: 0,
            left: 0,
        },
    },
    select: {
        padding: theme.spacing(1),
        color: theme.palette.text.primary
    },
    selectMenuPaper: {
        maxHeight: '160px',
    }
}));
